import { getActiveContentTab, TabType } from "owa-tab-store";
import { isReadingPanePositionOff } from "./readingPanePosition";

export default function isMailComposeActiveWithReadingPaneOff(): boolean {
    return isReadingPanePositionOff() && getActiveContentTab()?.type === TabType.MailCompose;
}
